import { Injectable, inject } from '@angular/core';
import { debounceTime, map, tap } from 'rxjs/operators';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import type { BatchEntry, BatchUpdateEntry } from './history.model';
import { HistoryChangeAction } from './history.model';
import HistoryActions from './history.actions';

@Injectable()
export class HistoryEffectsV2 {
    private readonly actions$ = inject(Actions);

    public readonly addBatchChangeToHistory$ = createEffect(() => {
        const updateEntries = new Map<string, BatchUpdateEntry>();
        const otherEntries: BatchEntry[] = [];

        return this.actions$.pipe(
            ofType(HistoryActions.addBatchChangeToHistory),
            tap(({ entry }) => {
                if (entry.action === HistoryChangeAction.update) {
                    const key = `${entry.entityType}:${entry.before.id}`;
                    const existing = updateEntries.get(key);
                    if (existing) {
                        existing.after = entry.after;
                    } else {
                        updateEntries.set(key, { ...entry });
                    }
                } else {
                    otherEntries.push(entry);
                }
            }),
            debounceTime(500),
            map(() => {
                const entries: BatchEntry[] = [...Array.from(updateEntries.values()), ...otherEntries];
                updateEntries.clear();
                otherEntries.length = 0;

                return HistoryActions.addChangeToHistory({
                    change: {
                        action: HistoryChangeAction.batch,
                        version: 2,
                        payload: { entries },
                    },
                });
            })
        );
    });
}
